import brace from 'brace';
import { Provider } from 'react-redux';
import store from './store/store';
import Draw from './components/draw';
import React from 'react';
import ReactDOM from 'react-dom';
import PageEditor from './components/page/page-editor';
import NavigationEditor from './components/flow/navigation-editor';
import ValueSelector from './components/value/value-reference-selector-wrapper';
import ValueSelectorTable from './components/value/value-selector-table';
import TypeSelector from './components/type/type-reference-selector';
import SharedElementSelector from './components/shared-element-selector';
import DefaultObjectDataEditor from './components/value/default-objectdata-editor';
import Form from './components/form';
import ComponentSelector from './components/page/component-selector';
import ComparisonRoot from './components/rule/comparison-root';
import ValueSelectorCustomComponent from './components/elementSelector/selectors/ValueSelectorCustomComponent';
import { ENV } from './constants';
import { startErrorNotifier } from './utils/errors';
import { initializeCurrentUser } from './actions/reduxActions/currentUser';

if (ENV !== null) {
    startErrorNotifier();
}

// Initialize Flow runtime settings
manywho.settings.initialize({
    adminTenantId: manywho.adminTenantId,
    playerUrl: [window.location.protocol, '//', window.location.host, window.location.pathname].join(''),
    joinUrl: [window.location.protocol, '//', window.location.host, window.location.pathname].join(''),
    platform: {
        uri: manywho.platformUri,
    },
    runtimeUri: manywho.runtimeUri,
    paging: {
        select: 25,
        value_selector: 100,
        shared_element_selector: 400,
    },
    shortcuts: {
        progressOnEnter: false,
    },
});

const registerComponent = (name, Component) => {
    manywho.component.register(name, props => (
        <Provider store={store} key={name}>
            <Component {...props} />
        </Provider>
    ));
};

// Add custom components needed for system flows
registerComponent('page_builder', PageEditor);
registerComponent('value_selector', ValueSelector);
registerComponent('type_selector', TypeSelector);
registerComponent('navigation_editor', NavigationEditor);
registerComponent('form', Form);
registerComponent('default_objectdata_editor', DefaultObjectDataEditor);
registerComponent('value_selector_table', ValueSelectorTable);
registerComponent('shared_element_selector', SharedElementSelector);
registerComponent('component_selector', ComponentSelector);
registerComponent('comparison', ComparisonRoot);
registerComponent('value_reference_selector', ValueSelectorCustomComponent);

store.dispatch(initializeCurrentUser());

// Start React render inside #manywho-draw element
const root = ReactDOM.render(
    <Provider store={store}>
        <Draw />
    </Provider>,
    document.getElementById('manywho-draw'),
);

export default root;
